module.exports = __webpack_public_path__ + "static/media/redeem3.77ef53bd.png";